import React from 'react';
import { Container, Row } from 'react-bootstrap';
import SupplierForm from './component/supplier/supplierForm';

const VendorRegister = () => {
  return (
    <div>
      <Container fluid>
        <Row>
          <div className="px-4">
            <h3 className="font-weight-bold mt-4 mb-0">Self Registration Form</h3>
            <div>
              <SupplierForm />
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default VendorRegister;
